import Container from 'src/components/Container'

const Calendar = (): JSX.Element => {
  return (
    <Container>
      <div>Calendar</div>
    </Container>
  )
}

export default Calendar
